import { render, staticRenderFns } from "./ChooseEntry.vue?vue&type=template&id=89452cca&scoped=true&"
import script from "./ChooseEntry.vue?vue&type=script&lang=js&"
export * from "./ChooseEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89452cca",
  null
  
)

export default component.exports